export const isUserCountryUK = () => {
  const userCountry = document.querySelector('meta[property="user-country"]').getAttribute('content');

  return ['UK', 'GB'].includes(userCountry);
};
